/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CheckoutSession } from "./CheckoutSession";
export const CreateCheckoutSessionResponse = core.serialization.object({
    data: CheckoutSession,
});
